import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkedAlt, faCertificate, faChartLine } from '@fortawesome/free-solid-svg-icons';
import './ContentSection.css';

const ContentSection = () => {
  return (
    <section className="content-section" id="services">
      <div className="content-container">
        <div className="section-header">
          <span className="section-label">What We Do</span>
          <h2>Field Marketing Services Built for Scale</h2>
          <p>Comprehensive door-to-door solutions for telecommunications providers</p>
        </div>
        
        <div className="services-grid">
          <div className="service-card">
            <div className="service-icon">
              <FontAwesomeIcon icon={faMapMarkedAlt} />
            </div>
            <h3>Territory Management</h3>
            <p>Strategic canvassing in high-value zip codes with proven conversion rates</p>
            <ul className="service-features">
              <li>Data-driven territory mapping</li>
              <li>Pre-qualified lead lists</li>
              <li>Multi-touch follow-up campaigns</li>
            </ul>
            <Link to="/services" className="service-link">View Coverage Map →</Link>
          </div>
          
          <div className="service-card">
            <div className="service-icon">
              <FontAwesomeIcon icon={faCertificate} />
            </div>
            <h3>Authorized Sales Program</h3>
            <p>Fully licensed and compliant representation of your brand</p>
            <ul className="service-features">
              <li>Brand-trained sales professionals</li>
              <li>Complete permit management</li>
              <li>Regulatory compliance guaranteed</li>
            </ul>
            <Link to="/services" className="service-link">Partner With Us →</Link>
          </div>
          
          <div className="service-card">
            <div className="service-icon">
              <FontAwesomeIcon icon={faChartLine} />
            </div>
            <h3>Performance Tracking</h3>
            <p>Real-time dashboards showing ROI and campaign metrics</p>
            <ul className="service-features">
              <li>Live sales reporting</li>
              <li>Territory heat maps</li>
              <li>Customer acquisition cost analysis</li>
            </ul>
            <Link to="/results" className="service-link">See Demo →</Link>
          </div>
        </div>
        
        <div className="content-cta">
          <h3>Ready to Transform Your Field Marketing?</h3>
          <p>Let's discuss how we can help grow your business with proven door-to-door strategies</p>
          <Link to="/contact" className="btn btn-primary">Contact Us Today</Link>
        </div>
      </div>
    </section>
  );
};

export default ContentSection;
